// MiniGameButton.js
var MiniGameButton = pc.createScript('miniGameButton');

// initialize code called once per entity
MiniGameButton.prototype.initialize = function () {

    this.entity.button.once('click', function (event) {

        showPlaceModUI = false;
        if (GameAnalyticsSdk.instance.gaStatus) { GameAnalytics("addDesignEvent", "MiniGamesButton:Click", 1); }
        loadScene(`MiniGames`, { hierarchy: true, settings: true });

    }, this);
};

// MiniGameButton.prototype.update = function () {

//     if (!startingAdDev) {
//         this.entity.button.active = true;
//     }
// };

